<template>
    <div>
        <base-header :type="gradienType" class="pb-6 pb-8 pt-5 pt-md-8">
            <!-- Card stats -->
            <!-- <div id="alertMessage">
            <base-alert type="default" dismissible>
                <span class="alert-inner--text"><strong>Default!</strong> This is a default alert—check it out!</span>
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </base-alert>
            </div> -->
        </base-header>

        <div class="container-fluid mt--7" :key="componentKey">
            <div class="row">
                <div class="col">
                    <div class="card shadow">
                        <div data-testid="document-title" class="card-header bg-transparent">
                             <base-dropdown>
                                <base-button data-testid="document-title-dropdown" slot="title" :type="buttonType" class="dropdown-toggle" disabled>
                                    Document - {{selectedDocumentName}}
                                </base-button>
                                <a v-for="documentType in documentTypes" :key="documentType.id" :value="documentType.id" class="dropdown-item" href="#" @click.prevent="setCurrentDocumentType(documentType.id, documentType.name, documentType.trans_code, documentType.type_code, documentType.friendly_code)">{{documentType.name}}</a>
                            </base-dropdown>
                        </div>

                        <div class="card mb-3">
                            <div class="row no-gutters">
                                <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                                    <div data-testid="document-filter" class="card-body py-2">
                                        <document-filter @changeFilter="changeFilter"></document-filter>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div data-testid="document-table" class="card-body pt-0">
                                        <!-- <dynamic-form :convertedJson="convertedJson" @valueUpdated="updateSettings"></dynamic-form> -->
                                        <!-- <dynamic-form :parameters="JSON.stringify(documentType)" :convertedJson="convertedJson" :key="componentKey"></dynamic-form> -->
                                        <documents-table :selectedDocumentName='selectedDocumentName' :documentType="documentType" :documentTypeDetails="documentTypeDetails"></documents-table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
  import HTTPRequest from '../../controllers/httpRequest.js'
  import DocumentFilter from './../DocumentFilter'
  import DocumentsTable from '../Tables/DocumentsTable.vue'
  //import DynamicForm from '../DynamicForm.vue'
  //var ObjGen = require('../../../node_modules/objgen/objgen.js').ObjGen
  import { mapState, mapActions } from 'vuex'
  import secureStorage from '../../controllers/secureStorage'
  import moment from 'moment'

  export default {
      data: function() {
          return {
              componentKey: 0,
              documentTypes: [],
              params: '',
              selectedDocumentName: null,
              documentType: null,
              gradienType: "instore",
              buttonType: "danger",
              documentTypeDetails:{}
          }
      },
      mounted: async function() {
        await this.getDocTypes();
      },
      computed: {
        ...mapState(['currentApiURL', 'endPoint', 'currentProfile']),
      },
      components:{
          DocumentFilter,
          DocumentsTable
      },
      methods:{
        moment,
        ...mapActions(['updateParameters', 'updateCurrentProfile']),
        setCurrentProfile(profile){
            this.updateCurrentProfile(profile)
        },
        scopedSiteFilterParam(documentTypeCode, siteId){
            if (!siteId) return ''

            const siteParamName = ['RECTRX', 'RECCSX'].includes(documentTypeCode) ? 'target_site_id' : 'site_id'
            return "&" + siteParamName + "=" + siteId
        },
        isAllSiteFilter(siteId){
            return siteId != null && siteId.toString() == '0'
        },
        setCurrentDocumentType(documentTypeId, documentTypeName, documentTypeTransCode, documentTypeCode, documentTypeFriendlyCode){
            var selectedDocumentTypeCode = documentTypeTransCode+documentTypeCode
            this.componentKey++
            secureStorage.setItem("documentTypeId", documentTypeId);
            secureStorage.setItem("documentTypeName", documentTypeName);
            secureStorage.setItem("documentTypeCode", selectedDocumentTypeCode);
            secureStorage.setItem("documentTypeFriendlyCode", documentTypeFriendlyCode);
            this.selectedDocumentName = secureStorage.getItem("documentTypeName")
            this.documentTypeDetails = {documentTypeId:documentTypeId,documentTypeName:documentTypeName,documentTypeCode:selectedDocumentTypeCode,documentTypeFriendlyCode:documentTypeFriendlyCode}
            // this.changeFilter(secureStorage.getItem("defaultSiteId").toString(), today.format('YYYY-MM-DD'), today.format('YYYY-MM-DD'), '', '', '');
            var defaultParams = this.params || this.scopedSiteFilterParam(selectedDocumentTypeCode, secureStorage.getItem("defaultSiteId"))
            this.setCurrentProfile("documents?document_type_id="+documentTypeId);
            this.updateParameters(defaultParams)
        },
        changeFilter(filterSite, searchDateFrom, searchDateTo, filterDateBy, filterStatus, filterOrderStatus, filterDocumentCode, filterReference, filterSupplier, filterCreatedBy, filterPostedBy, filterDeliveryTo, filterQuantity, filterOrderNo, filterOriginNo, filterDocumentNo, filterPurpose){
            this.params = ''
            var currentDocumentTypeCode = secureStorage.getItem("documentTypeCode")
            var selectedFilterSite = this.isAllSiteFilter(filterSite) ? null : filterSite
            if (selectedFilterSite && !(['RECTRX', 'RECCSX'].includes(currentDocumentTypeCode) && filterDeliveryTo)) this.params = this.params.concat(this.scopedSiteFilterParam(currentDocumentTypeCode, selectedFilterSite))
            if (searchDateFrom) this.params = this.params.concat("&searchDateFrom=" + searchDateFrom)
            if (searchDateTo) this.params = this.params.concat("&searchDateTo=" + searchDateTo)
            if (filterDateBy) this.params = this.params.concat("&filter_date_by=" + filterDateBy)
            if (filterStatus) this.params = this.params.concat("&status=" + filterStatus)
            if (filterOrderStatus) this.params = this.params.concat("&order_status=" + filterOrderStatus)
            if (filterDocumentCode) this.params = this.params.concat("&origin_document_no=" + filterDocumentCode)
            if (filterDocumentNo) this.params = this.params.concat("&document_no=" + filterDocumentNo)
            if (filterSupplier) this.params = this.params.concat("&supplier_id=" + filterSupplier)
            if (filterCreatedBy) this.params = this.params.concat("&created_by=" + filterCreatedBy)
            if (filterPostedBy) this.params = this.params.concat("&posted_by=" + filterPostedBy)
            if (filterDeliveryTo) this.params = this.params.concat("&target_site_id=" + filterDeliveryTo)
            if (filterQuantity) this.params = this.params.concat("&order_quantity=" + filterQuantity)
            if (filterOrderNo) this.params = this.params.concat("&order_no=" + filterOrderNo)
            if (filterOriginNo) this.params = this.params.concat("&order_origin_no=" + filterOriginNo)
            if (filterPurpose) this.params = this.params.concat("&purpose_id=" + filterPurpose)
            // console.log(filterReference)
            if(filterReference){
                for(var filter in filterReference){
                    // console.log(filter.field)
                    this.params = this.params.concat("&" + filterReference[filter]["field"] + "=" + filterReference[filter]["value"])
                }
            }
            this.updateParameters(this.params)
        },
        async getDocTypes(){
            //   alert(this.$route.query.type);
            var documentType = this.$route.query.type
            this.documentType = documentType
            this.documentTypes = await HTTPRequest.getRequest(this.endPoint + '/document_types/get_document_types_on_system_modules?code=' + documentType , null, null)
            // alert(JSON.stringify(this.documentTypes))

            // var selected_doc_type_id = secureStorage.getItem('documentTypeId')
            var selected_doc_type_id =  this.documentTypes[0].id

            // var selected_doc_type_id = this.documentTypes[0].id //TODO temp: set first document type as initial value selected
            //secureStorage.setItem('documentTypeId', selected_doc_type_id)
            //sets the selected document_type on page load
            if (this.documentTypes.length > 0){
              if (this.documentTypes.find(x => x.id === selected_doc_type_id)){
                  var initialDocumentType = this.documentTypes.find(x => x.id === selected_doc_type_id)
                  this.setCurrentDocumentType(initialDocumentType.id, initialDocumentType.name, initialDocumentType.trans_code, initialDocumentType.type_code, initialDocumentType.friendly_code)
              }
            }

            if(this.documentType.includes("PTP")){
                this.gradienType = "instore"
                this.buttonType = "primary"
            }else if(this.documentType.includes("IM")){
                this.gradienType = "instore"
                this.buttonType = "warning"
            }else{
                this.gradienType = "instore"
                this.buttonType = "danger"
            }

        },
        toSlug(str) {
            return str
            .toLowerCase()          // make all letters lowercase
            .trim()                 // remove leading/trailing spaces
            .replace(/\s+/g, '-')    // replace spaces with dashes
            .replace(/[^a-z0-9-]/g, ''); // remove any non-alphanumeric except dashes
        },
      },
      watch:{
        $route: async function () {
            await this.getDocTypes();
            this.componentKey++;
        },
    }
  };
</script>

<style>

</style>
